import { Route, Routes } from "react-router-dom";
import GatewaySetting from "pages/management/setting/iot/gateway";
import GatewayViewSetting from "pages/management/setting/iot/gateway-view";
import RouteAccessError from "pages/RouteAccessError";
import PermissionRoute from "components/route/PermissionRoute";
import { PERMISSIONS } from "config/permissions";

export default function MonitoringSettingGatewayRoutes(props) {

    return (
        <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_IOT_READ}
                        >
                            <GatewaySetting />
                        </PermissionRoute>
                    }
                />
                <Route path=":id" 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_IOT_READ}
                        >
                            <GatewayViewSetting />
                        </PermissionRoute> 
                    }
                 />
                <Route path="*" element={ <RouteAccessError /> }/>
            </Route>
        </Routes>
    );
}